import { useMemo } from 'react'
import { type SimpleSelectOption } from '@workwave-tidal/core/components'
import { useDateFnsOptions } from '@/hooks'
import { useRecurrenceState } from '../../../providers/StateProvider'
import { useCreateFormatRecurrenceWhenLabel } from './utils/useCreateFormatRecurrenceWhenLabel'
import { createDaysOfWeekOptions } from './utils/createDaysOfWeekOptions'
import { createMonthlyOptions } from './utils/createMonthlyOptions'
import { createAnnuallyOptions } from './utils/createAnnuallyOptions'

export function useOptions() {
  const {
    recurrencePeriod: { recurrenceType, date },
  } = useRecurrenceState()
  const { weekStartsOn, locale } = useDateFnsOptions()

  const formatRecurrenceWhenLabel = useCreateFormatRecurrenceWhenLabel()

  return useMemo<SimpleSelectOption<string>[]>(() => {
    switch (recurrenceType) {
      case 'NO_REPEAT':
      case 'DAILY': {
        return []
      }

      case 'WEEKLY': {
        return createDaysOfWeekOptions(weekStartsOn, formatRecurrenceWhenLabel)
      }

      case 'MONTHLY': {
        return createMonthlyOptions(date as uui.domain.YYYYMMDD, formatRecurrenceWhenLabel)
      }

      case 'ANNUALLY': {
        return createAnnuallyOptions(date as uui.domain.YYYYMMDD, formatRecurrenceWhenLabel)
      }
    }
  }, [recurrenceType, date, weekStartsOn, locale])
}
